<!--

  Esta pagina se refere aos 'capitulos' ou historias que serao escritos no site.


@Author Chris
-->

<template lang="html">
  <div class="page-container">

    <md-app class="viewport">
      <md-app-toolbar class="md-primary navbar" md-elevation="0">
        <navbar/>
      </md-app-toolbar>

      <md-app-content class="all-chapter">

        <div class="divsSliderMaps">

          <div v-if="media.length > 0">
            <slider :array="media" class="cardChapterSlider">
              <media slot-scope="{ current }" :url="current.url"/>
            </slider>
          </div>

          <div>
            <md-card class="cardChapterMinimap">
              <md-card-content>
                <md-card-header-text class="md-title link">
                  <md-icon>location_on</md-icon>
                  <span @click="$router.push({ name: 'place', params: { id: place.id }})">{{ place && place.name}}</span>
                </md-card-header-text>
                <minimap-markers v-if="place" class="minimap" :place="place" :chapter="chapter"/>
              </md-card-content>
            </md-card>
          </div>

        </div>


        <div class="divChapterAndComment">
          <md-card class="cardChapterStoryComment">
            <md-card-content>

              <story class="story" :place="place"/>

              <reactions />

            </md-card-content>
          </md-card>
        </div>

      </md-app-content>

    </md-app>

  </div>
</template>

<script>
import LogRocket from "logrocket";
import navbar from "../toolbar/navbar";
import slider from "../content/chapter/slide/slider";
import media from "../content/chapter/slide/media";
import story from "../content/chapter/story";
import reactions from "../content/chapter/reactions";
import minimapMarkers from "../drawer/maps/minimapMarkers";
import call from "@/api/calls";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  components: {
    navbar,
    slider,
    media,
    minimapMarkers,
    story,
    reactions
  },
  beforeRouteEnter(to, from, next) {
    call.chapter.get(to.params.id)
    .then(chapter => {
      if (chapter) {
        to.params.chapter = chapter;
        to.params.position = chapter.position;
        next();
      } else {
        next({ name: "notFound" });
      }
    })
    .catch(err => {
      to.params.error = err;
      log(err, "beforeRouteEnter()", null);
      next();
    });
  },
  data() {
    return {
      defaultMedia: [
        { url: "https://www.instagram.com/p/B4in1jsjSV4/?utm_source=ig_web_copy_link" },
        { url: "2IKOIT67ALc" },
        { url: "https://soundcloud.com/alanjhaseel/escuela-de-los-annales" },
        { url: "https://www.instagram.com/p/B5AwO3ZAW-y/?utm_source=ig_web_copy_link" },
        { url: "https://www.instagram.com/p/B5AxH7SgG00/?utm_source=ig_web_copy_link" },
        { url: "kRLTgA6IDVU" },
        { url: "L-Ds-FXGGQg" },
        { url: "https://soundcloud.com/glenncattanach/dancing-in-the-dark-bruce-springsteen" }
      ],
      place: null
    };
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    chapter() {
      return this.$route.params.chapter;
    },
    media() {
      if (this.chapter && Array.isArray(this.chapter.media))
        return this.chapter.media;
      else if (this.chapter == undefined && !this.$route.params.isProduction)
        return this.defaultMedia;
      return [];
    }
  },
  mounted() {
    this.getPlace()
    .then(place => this.$route.params.place = place);
    let oldRoute = this.$route.path;
    // deve ter um jeito melhor pra contar o view...
    setTimeout(() => {
      if (this.$route.path === oldRoute) {
        call.chapter.view(this.$route.params.id);
      }
    }, 10000); // Precisa de 10 segundos pra contar como view.
  },
  methods: {
    getPlace() {
      return call.group.get(this.chapter.group)
      .then(group => this.place = group);
    }
  },
  metaInfo() {
    return {
      title: this.chapter.title || "Capitulo",
      meta: [
        {name: "robots", content: "index"},
        {name: "keywords", content: `história, ${this.chapter.title}`},
        {name: "description", content: this.chapter.content},
        {rel: "canonical", href: `https://www.chapstory.com/c/${this.$route.params.id}`},
      //   // OpenGraph data (Most widely used)
      //   {property: 'og:title', content: 'My Page Title ← My Site'},
      //   {property: 'og:site_name', content: 'My Site'},
      //   // The list of types is available here: http://ogp.me/#types
      //   {property: 'og:type', content: 'website'},
      //   // Should the the same as your canonical link, see below.
      //   {property: 'og:url', content: 'https://www.my-site.com/my-special-page'},
      //   {property: 'og:image', content: 'https://www.my-site.com/my-special-image.jpg'},
      //   // Often the same as your meta description, but not always.
      //   {property: 'og:description', content: 'I have things here on my site.'},

      //   // Twitter card
      //   {name: 'twitter:card', content: 'summary'},
      //   {name: 'twitter:site', content: 'https://www.my-site.com/my-special-page'},
      //   {name: 'twitter:title', content: 'My Page Title ← My Site'},
      //   {name: 'twitter:description', content: 'I have things here on my site.'},
      //   // Your twitter handle, if you have one.
      //   {name: 'twitter:creator', content: '@chapstory'},
      //   {name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},

      //   // Google / Schema.org markup:
      //   {itemprop: 'name', content: 'My Page Title ← My Site'},
      //   {itemprop: 'description', content: 'I have things here on my site.'},
      //   {itemprop: 'image', content: 'https://www.my-site.com/my-special-image.jpg'}
      ]
    }
  }
};
</script>

<style scoped>
.md-content {
  background-color: #e4f9f54a;
}

.viewport {
  height: 100vh;
  width: 100vw;
}

.navbar {
  max-height: auto;
}

.md-toolbar,
.md-toolbar-row,
.md-app-toolbar,
.md-app-toolbar-row {
  width: 100%;
  min-height: 50px !important;
  display: flex;
  align-items: center;
  align-content: center;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: opacity, background-color, box-shadow, transform, color,
    min-height;
  will-change: opacity, background-color, box-shadow, transform, color,
    min-height;
}

.all-chapter {
  /* height: inherit; */
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 50px);
  /* background-color: #2226e2; */
}

.divButtonTop {
  height: 2.7em;
  margin-bottom: 1em;
  /* background-color: #fff; */
}

.buttonBack {
  position: fixed;
  height: 6%;
  margin: 0 auto;
  margin-left: 1.2em;
  z-index: 99999;
}

.divsSliderMaps {
  position: relative;
  float: left;
  width: 50%;
  margin: auto;
  margin-right: 0.5em;
}

.link {
  cursor: pointer;
}

.divChapterAndComment {
  float: right;
  width: 47%;
}

.chapter {
  /* position:absolute;  */
  height: 100%;
  overflow: hidden;
}

/* .md-app-content{
  max-height: 80px;
} */

.sidebar-chapter {
  /* position: sticky;
 top: 0; */
  max-width: 450px;
  width: 45vw;
  height: 100%;
  min-width: 300px;
  overflow-y: auto;
}

/* .liked-btn-wrapper {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: bold;
  float:left
}

.liked-btn-wrapper:hover, .liked-btn-wrapper:hover>.iconButton{
  border-color: #1b73a2;
  color: #1b73a2;
  background-color: white;
  cursor: pointer;
} */

.textarea-autogrow {
  max-width: 100%;
}

.commentChapter {
  top: 25px;
  left: 15px;
  padding: 0 2px;
  margin: 5px;
  background-color: #fff;
}

.md-field.md-focused label {
  top: 0;
  color: grey;
}

.md-field.md-theme-default:before {
  background-color: unset;
}

.md-textarea {
  min-height: 50px;
  padding: 15px;
  outline: 1px solid grey;
}

.md-textarea:focus {
  outline: auto;
}

.md-field.md-theme-default:after {
  background-color: unset;
}

.md-field {
  margin-bottom: 5px;
}

/* .field-comment{
  font-family: sans-serif;
  font-size: 14px;
  box-sizing: border-box;
  padding: 12px 20px;
  border: 1px solid #ccc;
  overflow: hidden;
  max-width: 100%;
  outline: 0;
  -webkit-appearance: none;
  border-radius: 50px;
  display: flex;
} */

/* .comment-btn-wrapper {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: bold;
  float:left;
  margin-left: 10px
}

.comment-btn-wrapper:hover, .comment-btn-wrapper:hover>.iconButton{
  border-color: #1b73a2;
  color: #1b73a2;
  background-color: white;
  cursor: pointer;
} */

.cardChapterStoryComment {
  position: relative;
  top: 0;
  float: right;
  width: 100%;
  margin: 0 auto;
}

.cardChapterSlider {
  position: relative;
  top: 0;
  float: left;
  width: 100%;
  margin: 0 0 1em;
  background-color: #5a5a5a;
}

.cardChapterMinimap {
  position: relative;
  top: 0;
  float: left;
  width: 100%;
  margin: 0 0 1em;
}

.minimap {
  height: 250px;
}

@media (max-width: 2560px) {
  .buttonBack {
    height: 3%;
  }
}

@media (max-width: 1024px) {
  .buttonBack {
    height: 6%;
  }
}

@media (max-height: 1366px) {
  .buttonBack {
    height: 3%;
  }
}

@media (max-height: 768px) {
  .buttonBack {
    height: 5%;
  }
}

@media (max-width: 823px) {
  /* ::-webkit-scrollbar-track {
    opacity: 0;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #c6e7e1;
  }
  ::-webkit-scrollbar-thumb {
    background: #11999e;
  } */

  .buttonBack {
    position: relative;
    margin: 0;
    height: 95%;
  }

  .divsSliderMaps {
    width: 100%;
    margin-right: 0;
  }

  .divChapterAndComment {
    float: left;
    width: 100%;
  }
}

@media (max-width: 768px) {
  /* ::-webkit-scrollbar-track {
    opacity: 0;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #c6e7e1;
  }
  ::-webkit-scrollbar-thumb {
    background: #11999e;
  } */

  .buttonBack {
    position: relative;
    margin: 0;
    height: 95%;
  }

  .divsSliderMaps {
    width: 100%;
  }

  .divChapterAndComment {
    float: left;
    width: 100%;
  }
}

@media (max-width: 414px) {
  /* ::-webkit-scrollbar-track {
    opacity: 0;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #c6e7e1;
  }
  ::-webkit-scrollbar-thumb {
    background: #11999e;
  } */

  .buttonBack {
    position: relative;
    margin: 0;
    height: 100%;
  }

  .divsSliderMaps {
    width: 100%;
  }

  .divChapterAndComment {
    float: left;
    width: 100%;
  }
}
</style>
